import { useEffect, useState } from "react";
import adminUseFetchSiteMaterials from "../../custom_hook/adminUseFetchSiteMaterials";

interface Metrics {
  numberOfPosts: number;
  numberOfBooks: number;
  numberOfSolutions: number;
  numberOfChapters: number;
}
const AdminDashboard = () => {
  const [metrics, setMetrics] = useState<Metrics | null>(null);
  const { books, blogposts, chapters, solutions } =
    adminUseFetchSiteMaterials();
  useEffect(() => {
    const data: Metrics = {
      numberOfBooks: books?.length,
      numberOfChapters: chapters?.length,
      numberOfPosts: blogposts?.length,
      numberOfSolutions: solutions?.length,
    };
    setMetrics(data);
  }, [books, blogposts, chapters, solutions]);

  return (
    <>
      <div className="main-content">
        <div className="metric-card">
          <div id="md-book">Books</div>

          <div id="md-book-value">{metrics?.numberOfBooks}</div>
        </div>
        <div className="metric-card">
          <div id="md-book">Blog Posts</div>

          <div id="md-book-value">{metrics?.numberOfPosts}</div>
        </div>
        <div className="metric-card">
          <div id="md-book">Chapters</div>

          <div id="md-book-value">{metrics?.numberOfChapters}</div>
        </div>
        <div className="metric-card">
          <div id="md-book">Solutions</div>

          <div id="md-book-value">{metrics?.numberOfSolutions}</div>
        </div>
        <div className="metric-card">
          <div id="md-book">Pending Solutions</div>

          <div id="md-book-value">
            {metrics
              ? (metrics.numberOfChapters ?? 0) -
                (metrics.numberOfSolutions ?? 0)
              : 0}{" "}
            {"*"}
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminDashboard;
